import React from 'react';
import {observer} from 'mobx-react';
import {ProductCustomizationState} from './render.def';
// IMPORTANT: MUST NOT import from s.ts (product store) - this renderer code is used in multiple apps for image rendering

interface Props {
    pcs: ProductCustomizationState;
}

// Renders CustomizationMethodID = 1
export const FrameOld = observer(({pcs}: Props) => {
    return (
        <div
            id="frame-old-container"
            style={{padding: `${pcs.css.moulding_half}px 0`}}
            role="img"
            aria-label={pcs.ADA}
        >
            <div id="frame-old-container-inner">
                <img
                    id="frame-old"
                    className="img-core"
                    src={pcs.old_style_composite.includes('oldstyle') ? `https://${pcs.CDNDomain}/images/products/composites/${pcs.old_style_composite}` : `https://${pcs.CDNDomain}/images/products/composites/primary/${pcs.old_style_composite}`}
                    alt={`Product Image of ${pcs.ProductName_Original}`}
                />
                <img
                    id="m_topleft"
                    className="old-moulding z4"
                    alt=""
                    src={pcs.css.m_topleft_src}
                    style={{
                        left: `-${pcs.css.moulding_half}px`,
                        top: `-${pcs.css.moulding_half}px`,
                        width: pcs.css.m_topleft_width,
                    }}
                />
                <img
                    id="m_topright"
                    className="old-moulding z4"
                    alt=""
                    src={pcs.css.m_topright_src}
                    style={{
                        right: `-${pcs.css.moulding_half}px`,
                        top: `-${pcs.css.moulding_half}px`,
                        width: pcs.css.m_topright_width,
                    }}
                />
                <img
                    id="m_bottomright"
                    className="old-moulding z4"
                    alt=""
                    src={pcs.css.m_bottomright_src}
                    style={{
                        right: `-${pcs.css.moulding_half}px`,
                        bottom: `-${pcs.css.moulding_half}px`,
                        width: pcs.css.m_bottomright_width,
                    }}
                />
                <img
                    id="m_bottomleft"
                    className="old-moulding z4"
                    alt=""
                    src={pcs.css.m_bottomleft_src}
                    style={{
                        left: `-${pcs.css.moulding_half}px`,
                        bottom: `-${pcs.css.moulding_half}px`,
                        width: pcs.css.m_bottomleft_width,
                    }}
                />
                <img
                    id="m_left"
                    className="old-moulding z3"
                    alt=""
                    src={pcs.css.m_left_src}
                    style={{
                        left: `-${pcs.css.moulding_half}px`,
                        width: pcs.css.m_left_width,
                        height: pcs.css.m_left_height,
                    }}
                />
                <img
                    id="m_top"
                    className="old-moulding z3 w100"
                    alt=""
                    src={pcs.css.m_top_src}
                    style={{
                        top: `-${pcs.css.moulding_half}px`,
                        left: 0,
                        width: pcs.css.m_top_width,
                        height: pcs.css.m_top_height,
                    }}
                />
                <img
                    id="m_right"
                    className="old-moulding z3"
                    alt=""
                    src={pcs.css.m_right_src}
                    style={{
                        right: `-${pcs.css.moulding_half}px`,
                        width: pcs.css.m_right_width,
                        height: pcs.css.m_right_height,
                    }}
                />
                <img
                    id="m_bottom"
                    className="old-moulding z3 w100"
                    alt=""
                    src={pcs.css.m_bottom_src}
                    style={{
                        bottom: `-${pcs.css.moulding_half}px`,
                        left: 0,
                        width: pcs.css.m_bottom_width,
                        height: pcs.css.m_bottom_height,
                    }}
                />
                {pcs.ProductTypeID === 5 && (
                    <div className="tassel-cord tassel-cord-1">
                        <picture>
                            <source
                                type="image/webp"
                                srcSet={`https://${pcs.CDNDomain}/images/cached/general/honor-cord1.webp`}
                            />
                            <img
                                width="128"
                                height="128"
                                src={`https://${pcs.CDNDomain}/images/cached/general/honor-cord1.png`}
                                alt="Frame Also Holds Cord"
                                loading="lazy"
                            />
                        </picture>
                    </div>
                )}
            </div>
        </div>
    );
});
